import { queryKeys } from 'api/queryKeys'

export const getDefaultQueryKeys = (jobSummaryId: string) => [
  queryKeys.validateComponent,
  'jobId',
  jobSummaryId,
  'components'
]
